module.exports = __webpack_public_path__ + "static/media/Portrait-10016_original.c9baa7d4.jpg";